module.exports = __webpack_public_path__ + "img/photo-0112.7ec529e0.jpg";